// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__33o_S","header":"ClearentDisclaimer_header__3t8dz","inner":"ClearentDisclaimer_inner__1ZAvK"};